import { BrighteFooter } from '@components/Brighte';
import { usePackageContext } from '@provider';
import { PAGE_FOOTER } from '@utils/constants';

export const Footer = () => {
  const { packageForm } = usePackageContext();
  const { financialProduct } = packageForm;

  const financialProductId = financialProduct?.id;
  const termsLink = PAGE_FOOTER.TERMS[financialProductId ?? ''];

  // acknowledgement of country will be removed soon once confirmed
  return <BrighteFooter termsLink={termsLink} showAcknowledgement />;
};
